import {
  Box,
  Divider,
  Secondary,
  Stack,
  Strong,
  Text,
} from 'braid-design-system';
import * as styles from './ProfileMenu.css';
import { useAuth0 } from '@auth0/auth0-react';
import { useSelf } from '#src/hooks/self.ts';
import { useOrganizations } from '#src/pages/manage/organizations/OrganizationContext.tsx';
import { useNavigate } from 'react-router';
import { DarkMode } from './components/DarkMode.tsx';
import { ProfileMenuItem } from './components/ProfileMenuItem.tsx';
import { ProfileMenuHeading } from './components/ProfileMenuHeading.tsx';
import { OrganizationSelection } from './components/OrganizationSelection.tsx';
import { useLogin } from '#src/hooks/auth.tsx';

export const ProfileMenu = () => {
  const { organizations } = useOrganizations();
  const { user, logout, isAuthenticated } = useAuth0();
  const { login } = useLogin();
  const { self } = useSelf();

  const navigate = useNavigate();

  const currentPartner = self?.partner.name ?? 'Developer Dashboard';

  return (
    <Box
      className={styles.profileMenu}
      background="surface"
      paddingTop="small"
      paddingBottom="small"
    >
      {isAuthenticated ? (
        <Stack space="xsmall">
          <ProfileMenuItem onClick={() => navigate('/manage/user-profile')}>
            <Stack space="small">
              <Text size="small">
                <Strong>{user?.name}</Strong>
              </Text>
              <Text size="small">
                <Secondary>{currentPartner}</Secondary>
              </Text>
            </Stack>
          </ProfileMenuItem>

          <Divider />

          {organizations.length > 1 ? (
            <>
              <ProfileMenuHeading>Switch Account</ProfileMenuHeading>
              <OrganizationSelection />

              <Divider />
            </>
          ) : null}

          <ProfileMenuHeading>Dark Mode</ProfileMenuHeading>
          <DarkMode />

          <Divider />

          <ProfileMenuItem
            onClick={() => {
              logout({
                logoutParams: {
                  returnTo: window.location.origin,
                },
              });
            }}
          >
            <Text size="small">Log out</Text>
          </ProfileMenuItem>
        </Stack>
      ) : (
        <Stack space="xsmall">
          <ProfileMenuHeading>Dark Mode</ProfileMenuHeading>
          <DarkMode />
          <Divider />
          <ProfileMenuItem onClick={() => login({})}>
            <Text size="small">Sign in</Text>
          </ProfileMenuItem>
        </Stack>
      )}
    </Box>
  );
};
